<template>
  <Button variant="text" class="chat-widget__settings-button" type="button" :disabled="!useChat.dialog?.id" icon="pi pi-download" label="Экспортировать" @click="toggle" />

  <Popover ref="op">
    <Button icon="pi pi-file-pdf" severity="secondary" text label="PDF" @click="exportPdf" />
    <Button icon="pi pi-file-word" severity="secondary" text label="Word" @click="exportWord" />
  </Popover>
</template>

<script setup>
import Button from 'primevue/button';
import Popover from "primevue/popover";
import {ref} from "vue";
import {useChatStore} from '@/modules/chat/stores/chatStore';

const op = ref();

const toggle = (event) => {
  op.value.toggle(event);
}

const useChat = useChatStore();

const exportPdf = () => {
  const chatId = useChat.dialog.id;
  window.open(`/dialogs/${chatId}/export/pdf`, '_blank');
}

const exportWord = () => {
  const chatId = useChat.dialog.id;
  window.open(`/dialogs/${chatId}/export/word`, '_blank');
}
</script>
